import axios from "axios";



export const sendSms = (mobile, token) => {

    const smsBody = {

        token: token,
        mobile: mobile
    }

    //for send sms
    axios
        .post("https://panel.hamkadeh.com/api/v2/sms-system/send-sms", smsBody)
        .then(res => {

            res.data.status ? console.log("send sms is ok") : console.log("send sms is Not ok!!!");

        })

}


export const script1 = () => {

    var actionName = "B60CallToAction";
    var urlParams = new URLSearchParams(window.location.search);
    var iid = urlParams.get('utm_ma');
    if (iid) {
        var xhr = new XMLHttpRequest();
        xhr.withCredentials = !0;
        xhr.open("GET", "https://api.mediaad.org/v1/events/post-back?actionName=" + actionName + "&clickId=" + iid, false);
        xhr.send();
        console.log('send-data-ok');
    }

}


